// extracted by mini-css-extract-plugin
export default {"Arrow":"Spinner_Arrow__mM91L","right":"Spinner_right__35joN"};